import * as React from 'react';
import ProductGallery from './Gallery/ProductGallery';
import Availability from './Availability';
import { HTML_CLASSES } from '../../../../constants/product.constants';
import { shouldShowAvailability } from '../../../../utils/availability.utils';
import { useProductContext } from '../../../../contexts/ProductContext';

export const ProductImageColumn: React.FC = () => {
    const {
        productConfig,
        selectedProductInformation,
        setIsLoadingAvailability,
        availabilityConfig,
    } = useProductContext();

    const showAvailability = shouldShowAvailability(
        productConfig.type,
        !!selectedProductInformation?.productId,
        availabilityConfig,
    );

    return (
        <div className={HTML_CLASSES.LAYOUT_PRODUCT_IMAGE}>
            <div className={HTML_CLASSES.PRODUCT_IMAGE}>
                <ProductGallery />
            </div>

            {productConfig.productNuggets && <div dangerouslySetInnerHTML={{ __html: productConfig.productNuggets }} />}

            {showAvailability && availabilityConfig && (
                <Availability
                    items={availabilityConfig.items}
                    productId={selectedProductInformation?.productId}
                    availabilityLabel={availabilityConfig.availabilityLabel}
                    setIsLoadingAvailability={setIsLoadingAvailability}
                />
            )}
        </div>
    );
};
